// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SelectionFieldPopupAction.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field selection component
 */

import { curry, map, isEmpty, includes, flow, uniqBy, uniq, compact } from 'lodash/fp';
import { withHandlers, compose, withProps } from 'recompose';
import ReportPartFieldConstants from 'logic/data/Izenda.ReportPartFieldConstants';
import commonDataUtils from 'logic/Izenda.ReportDesignerCommonDataUtils';

export default compose(
  withProps(() => ({
    popupFields: {
      selectedData: []
    }
  })),
  withHandlers({
    closed: curry(closed),
    onChangeSeletedField: curry(onChangeSeletedField)
  })
);

function closed(props: any, closeFunc: any, type: any) {
  if (type === 'cancel') {
    props.onReject();
    props.popupFields.selectedData = [];
  } else {
    // const props = this.props;
    const {container, reportPart} = props;
    const selectedFields = map(function(item) {
      const querySource = props.store.displayFieldQuerySource[item.querySource];
      const field = querySource.fields[item.field];

      return {
        field: field,
        querySource: querySource
      };
    }, props.popupFields.selectedData);

    const result = props.validateAddNewFieldToReportPart(map('field', selectedFields), false);
    let position = container.elements.length;
    let validField = false;


    if (!isEmpty(selectedFields)) {

      // Collect data types + query source id's:
      const allDataTypes = flow(
        map(item => ({
          dataType: item.field.izendaDataType,
          querySourceId: item.querySource.id
        })),
        uniqBy(x => `${x.dataType}_${x.querySourceId}`),
        compact
      )(selectedFields);

      // Run preload promises:
      let preloadPromises = {
        promiseFunctions: null,
        promiseFormats: null
      };
      if (!isEmpty(allDataTypes)) {
        preloadPromises = {
          // Load functions for all selected fields
          promiseFunctions: commonDataUtils.getFunctionsData(
            ReportPartFieldConstants.FIELD_FUNCTION_MODE.FieldProperty,
            allDataTypes
          ),
          // Load formats for all selected fields
          promiseFormats: commonDataUtils.getFormatsData(
            uniq(map('dataType', allDataTypes))
          )
        };
      }

      return props
        .confirmTurnOffMultiColor()
        .then(props.confirmRemoveRegressionLine)
        .then(() =>
          // Add all fields
          Promise.map(selectedFields, item => {
            if (!includes(item.field, result.errorField)) {
              position++;
              validField = true;
              return props.addField(item.field, item.querySource, position, preloadPromises);
            }
            return Promise.resolve();
          })
            .then(() => {
              if (isEmpty(result.message)) {
                return null;
              }
              return !isEmpty(result.message) && props.warning(result.message);
            })
            .then(() => {
              if (validField) {
                props.onAccept();
                props.reportPart.shouldUpdatePreview && props.store.needUpdatePreview();
              }
            })
            .finally(() => {
              props.popupFields.selectedData = [];
            })
        );
    } else {
      props.onAccept();
    }
  }
}

function onChangeSeletedField(props: any, data: any) {
  props.popupFields.selectedData = data;
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.SelectionFieldPopupAction.js